module.exports = __webpack_public_path__ + "media/public/images/icon-arrow-next-6e17563eaa04055261e4bf054757b460.svg";